<ng-container *ngIf="errors">
  <mat-error *ngFor="let error of errors">{{ error }}</mat-error>
</ng-container>
